import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { normalize } from '../utils';
import { union } from 'lodash';

const resource = (state, { type, payload }) => {
  switch (type) {
    case 'INSTALLER_RESOURCE_REQUEST':
      return {
        ...state,
        ...payload,
        loading: true,
      };
    case 'INSTALLER_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state, // Not sure if I should leave the old state here
        ...payload,
        loading: false,
      };
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'INSTALLER_RESOURCE_REQUEST':
    case 'INSTALLER_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS': {
      const id = payload.id !== null && payload.id !== undefined ?
                 payload.id : payload.result;
      // If payload has an id, it's a REQUEST action otherwise
      // the id is in the result field from normalizr
      const resourcePayload = payload.entities && payload.entities.installers
                           && payload.entities.installers[id];
      return {
        ...state,
        [id]: resource(state[id], { type, payload: resourcePayload }),
      };
    }
    case 'INSTALLER_LIST_SUCCESS':
      return Object.assign({}, state, normalize(payload.installers));
    case 'ADD_EVENT_TO_INSTALLER_SUCCESS': {
      const clonedState = Object.assign({}, state);
      clonedState[payload.installerId] = {
        ...clonedState[payload.installerId],
        events: 'events' in state[payload.installerId] ? [payload.event, ...state[payload.installerId].events] : [payload.event],
      };
      return clonedState;
    }
    case 'ADD_EVENT_TO_INSTALLER_FAILURE':
    default:
      return state;
  }
};

const defaultFilters = {
  data: {
    is_active: true,
    for_workrooms: [],
    is_pending: null,
    query: null,
  },
  idsByFilter: [],
};

const filters = (state = defaultFilters, { type, payload }) => {
  switch (type) {
    case 'INSTALLER_LIST_SUCCESS':
      return {
        ...state,
        idsByFilter: union(state.idsByFilter || [], payload.installers.map(item => item.id)),
      };
    case 'INSTALLER_SET_FILTER':
      return {
        ...state,
        data: Object.assign({}, payload),
      };
    case 'INSTALLER_RESET_FILTERS':
      return defaultFilters;
    // When a installer is created/updated the easiest behaviour is to reset pagination
    // so the filters are properly updated in the listing screen
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS':
    case 'INSTALLER_RESET_PAGINATION':
      return {
        ...state,
        idsByFilter: [],
      };
    default:
      return state;
  }
};

const initialState = {
  loading: false,
  errors: {},
  page: 1,
  hasNextPage: true,
};

const common = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'INSTALLER_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'INSTALLER_RESET_PAGINATION':
      return {
        ...state,
        page: 1,
        hasNextPage: true,
      };
    case 'INSTALLER_RESOURCE_CREATE_SUCCESS':
    case 'INSTALLER_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        errors: {},
        page: 1,
        hasNextPage: true,
      };
    case 'INSTALLER_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        page: state.page + 1,
        hasNextPage: payload.has_next_page,
      };
    case 'INSTALLER_LIST_FAILURE':
    case 'INSTALLER_RESOURCE_CREATE_FAILURE':
    case 'INSTALLER_RESOURCE_UPDATE_FAILURE':
    case 'INSTALLER_RESOURCE_SYNC_VALIDATION_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    case 'INSTALLER_RESOURCE_REQUEST':
    case 'INSTALLER_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_CLEAR_VALIDATION':
      return {
        ...state,
        errors: {},
      };
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  common,
  filters,
});

const getById = state => state.byId;
const getHasNextPage = state => state.common.hasNextPage;
const getPage = state => state.common.page;
const getLoading = state => state.common.loading;
const getVisibleFilter = state => state.filters.data.status;
const getFiltersData = state => state.filters.data;
const idsByFilter = state => state.filters.idsByFilter;
const getErrors = state => state.common.errors;

const getList = createSelector(
  getById,
  idsByFilter,
  (lookup, list) => list.map(id => lookup[id]),
);

const getInactiveVisible = createSelector(
  getVisibleFilter,
  status => status === 'all',
);

export {
  getList,
  getHasNextPage,
  getPage,
  getLoading,
  getErrors,
  getById,
  getInactiveVisible,
  getFiltersData,
};



// WEBPACK FOOTER //
// ./client/app/reducers/installers.js